import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.visualMain = this.$('visual-main')[0]
        this.visualSecondary = this.$('visual-secondary')[0]
        this.image = this.$('image')[0]
        this.titleLines = this.$('title-line')
        this.pageTitle = this.$('page-title')[0]

        this.compute();
        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        this.initTl();
    }

    initTl() {
        if(this.timeline && this.timeline.kill) {
            this.timeline.kill()
            this.timeline = null;
        }

        gsap.set(this.visualMain, { clearProps: 'top,width,height,borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius,backgroundSize' });
        gsap.set([...this.titleLines, this.pageTitle], { clearProps: 'all' });

        this.timeline = gsap.timeline({
            repeat: -1,
            repeatDelay: .5,
            yoyo: true
        });

        this.timeline.to(this.visualMain, {
            width: this.viewport.width*1.2,
            height: this.viewport.height*1.2,
            borderTopLeftRadius: this.viewport.width*0.1,
            borderTopRightRadius: this.viewport.width*0.1,
            borderBottomRightRadius: this.viewport.width*0.1,
            borderBottomLeftRadius: this.viewport.width*0.1,
            backgroundSize: this.viewport.ratio > 16/9 ? `120vw auto` : `auto ${this.viewport.height*1.4}`,
            duration: 1,
            ease: 'linear'
        }, 0)

        if(!this.viewport.isMobile) {
            this.timeline.to(this.titleLines[0], {
                y: '100%',
                opacity: 0,
                duration: 0.4,
                ease: 'power1.in'
            }, 0.4);

            this.timeline.to(this.titleLines[1], {
                y: '100%',
                duration: 0.4,
                ease: 'power1.in'
            }, 0.4);

            this.timeline.to(this.pageTitle, {
                y: '-100%',
                duration: 0.4,
                ease: 'power1.in'
            }, 0.4);
        }

        this.timeline.pause()
        this.timeline.progress(0)

        // this.timeline.to(this.image, {
        //     scale: 1,
        //     duration: 1,
        //     ease: 'linear',
        //     force3D: true
        // }, 0)
    }

    compute() {
        if(this.viewport && this.viewport.isMobile && this.viewport.width == window.innerWidth) return false;

        const vw = window.innerWidth
        const vh = window.innerHeight
        const isMobile = vw < 1000 || !document.documentElement.classList.contains('has-scroll-smooth');

        this.viewport = {
            width: vw,
            height: vh,
            isMobile
        }

        this.viewport.ratio = this.viewport.width / this.viewport.height;

        return true;
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.onResize()
                this.resizeTick = false
            })
        }
    }    

    onResize() {
        if(this.compute()) {
            this.initTl();
        }
    }

    onScroll(progress) {
        if(this.timeline && this.timeline.progress) {
            this.timeline.progress(progress)
        }
    }

    destroy() {
        if(this.timeline && this.timeline.kill) {
            this.timeline.kill()
            this.timeline = null;
        }
    }
}
